'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Widgets.Combobox'];
module.exports = angular.module('AVRO.DemandPosting.DemandPostingType', dependencies).controller('DemandPostingTypeController', require('./controllers/DemandPostingTypeController')).directive('rmDemandPostingType', require('./directives/DemandPostingTypeDirective'));